(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["EP_Announcement"] && !Shopify.designMode) return;
  try {
    
function Marquee(selector, speed) {
  const parentSelector = document.querySelector(selector);
  const clone = parentSelector.innerHTML;
  const firstElement = parentSelector.children[0];
  let i = 0;
  let marqueeInterval;

  parentSelector.insertAdjacentHTML('beforeend', clone);
  parentSelector.insertAdjacentHTML('beforeend', clone);

  function startMarquee() {
    marqueeInterval = setInterval(function () {
      firstElement.style.marginLeft = `-${i}px`;
      if (i > firstElement.clientWidth) {
        i = 0;
      }
      i = i + speed;
    }, 0);
  }

  function stopMarquee() {
    clearInterval(marqueeInterval);
  }

  parentSelector.addEventListener('mouseenter', stopMarquee);
  parentSelector.addEventListener('mouseleave', startMarquee);

  startMarquee();
}

window.addEventListener('load', () => Marquee('.marquee', 0.3));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["EP_Blog_Recent_Articles"] && !Shopify.designMode) return;
  try {
    
  const swiperElrs = document.querySelector('swiper-container.recent_articles_slider')
      Object.assign(swiperElrs, {
        slidesPerView: 1.3,
        spaceBetween: 30,
        centeredSlides: true,
        loop: false,
        pagination: true,
        navigation: {
        prevEl: '.EP_Article_pg_full-width-relatad-article-section .prev-trigger',
        nextEl: '.EP_Article_pg_full-width-relatad-article-section .next-trigger',
        },
        breakpoints: {
          390: {
            slidesPerView: 1.3,
            spaceBetween: -30,
            centeredSlides: true,
            loop: true,
          },
          600: {
            slidesPerView: 1.9,
            spaceBetween: -30,
            centeredSlides: true,
            loop: true,
          },
          767: {
            slidesPerView: 2.3,
            spaceBetween: 10,
            centeredSlides: true,
            loop: true,
          },
          768: {
            slidesPerView: 2.3,
            spaceBetween: 10,
            centeredSlides: false,
            loop: false,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 15,
            centeredSlides: false,
            loop: false,
          },
        },
        pagination: {
        el: '.EP_Article_pg_full-width-relatad-article-section .swiper-pagination-mobile',
  			clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
      },
      });
    swiperElrs.initialize();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["EP_FAQ_v2_Page_Section"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function($) {
      $('#faq-topics').select2({
          placeholder: 'Select Category',
          minimumResultsForSearch: Infinity,
          dropdownCssClass: 'faq-category-dropdown'
      });
  
      // When the dropdown value changes
      $('#faq-topics').change(function() {
      var selectedCategory = $(this).val();
  
      // If 'Select Category' (default) is chosen, do nothing
      if (selectedCategory === '') {
          return;
      }
  
      // Get the height of the header and add an extra offset for clarity
      var headerHeight = $('.header-wrapper').outerHeight() + 40;
  
      // Scroll to the corresponding category section
      $('.category-section').each(function() {
          var category = $(this).find('.category-title').text().trim();
  
          if (category === selectedCategory) {
              $('html, body').animate({
                  scrollTop: $(this).offset().top - headerHeight
              }, 500);
  
              // Reset the select element to allow re-selection of the same category
              setTimeout(function() {
                  $('#faq-topics').val('').trigger('change');
              }, 500);
  
              return false; // Break the loop once we find the matching category
            }
        });
    });
  
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["EP_Home-slider"] && !Shopify.designMode) return;
  try {
    
  
    const swiperEl1 = document.querySelector('swiper-container.EP_hero-slider')
    const params1 = {
      injectStyles: [`
      .swiper-pagination-bullet {
        width: 17px;
        height: 17px;
        opacity: 1;
        border: 1px solid black;
      }
      .swiper-pagination-bullet-active {
        border: 1px solid transparent;
      }
      .swiper {
        max-height:912px;
      }

      .swiper-pagination {
        padding-bottom: 35px;
      }
      
      @media screen and (max-width: 767px) {
        .swiper-pagination {
          display: none !important;
        }
      }
      
      `]
    }
    Object.assign(swiperEl1, params1);
    swiperEl1.initialize();
  
    // const progressCircle = document.querySelector(".EP_hero-slider .autoplay-progress svg");
    // const progressContent = document.querySelector(".EP_hero-slider .autoplay-progress span");

    // const swiperElc = document.querySelector("swiper-container.EP_hero-slider");
    // swiperElc.addEventListener("autoplaytimeleft", (e) => {
    //   const [swiper, time, progress] = e.detail;
    //   progressCircle.style.setProperty("--progress", 1 - progress);
    //   progressContent.textContent = `${Math.ceil(time / 1000)}s`;
    // });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["EP_Home_our-mission"] && !Shopify.designMode) return;
  try {
    

const swiperEl2 = document.querySelector('swiper-container.EP_about-slider');
const params2 = {
  injectStyles: [`
    .swiper-pagination-bullet {
      opacity: 1;
      border: 1px solid white;
    }
    .swiper-pagination-bullet-active {
      border: 1px solid white;
    }
    @media (min-width:768px) {
    .swiper-pagination-bullet {
      width: 17px;
      height: 17px;
    }
    }
    .swiper-button-next, .swiper-button-prev {
        z-index: 20 !important;
    }
    .swiper-button-next {
  background-image: url('https://cdn.shopify.com/s/files/1/0768/0376/8604/files/arrow-right.svg?v=1688619526');
  background-repeat: no-repeat;
    background-position: center;
        background-size: contain;
}

.swiper-button-prev {
  background-image: url('https://cdn.shopify.com/s/files/1/0768/0376/8604/files/arrow-left.svg?v=1688619525');
  background-repeat: no-repeat;
    background-position: center;
        background-size: contain;
}
.swiper-button-next:after, .swiper-button-prev:after {
opacity:0;
}
@media (min-width:768px) {
    .swiper-wrapper {
    padding-bottom: 95px;
    }
}
    @media (max-width:767px) {
    .swiper-pagination-bullet {
      width: 9px;
      height: 9px;
    }
    .swiper-wrapper {
    padding-bottom:0px;
    }
    }
.swiper-button-next:after, .swiper-button-prev:after {
font-weight:bold;
}
    `
  ]
};
Object.assign(swiperEl2, params2);
swiperEl2.initialize();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["EP_Home_our-recipes"] && !Shopify.designMode) return;
  try {
    
  
  const swiperEl3 = document.querySelector('swiper-container.recipes_slider')
  const params3 = {
    injectStyles: [`
    .swiper-pagination {
       z-index:4;
    }
    .swiper-pagination-bullet {
          width: 7px;
          height: 7px;
          opacity: 1;
          border: 1px solid white;
    }
    .swiper-pagination-bullet-active {
      border: 1px solid white;
    }
    .swiper-button-next:after, .swiper-button-prev:after {
      font-weight: bold;
  }
  @media (max-width:980px) {
  .swiper-wrapper {
  padding-bottom:80px;
  }
  }
    @media (max-width:390px) {
  .swiper-wrapper {
  padding-bottom:50px;
  }
  }
    .swiper-button-next {
  background-image: url('https://cdn.shopify.com/s/files/1/0743/8375/3517/files/arrow-right-orange.svg?v=1688538636');
  background-repeat: no-repeat;
    background-position: center;
        background-size: contain;
}

.swiper-button-prev {
  background-image: url('https://cdn.shopify.com/s/files/1/0743/8375/3517/files/arrow-left-orange.svg?v=1688538636');
  background-repeat: no-repeat;
    background-position: center;
        background-size: contain;
}
.swiper-button-next:after, .swiper-button-prev:after {
opacity:0;
}
    `]
  }
  Object.assign(swiperEl3, params3);
  swiperEl3.initialize();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["EP_Home_static-review-slider"] && !Shopify.designMode) return;
  try {
    
const swiperEl5 = document.querySelector('swiper-container.review-slider')
    Object.assign(swiperEl5, {
      slidesPerView: 1.3,
      spaceBetween: 28,
      centeredSlides: true,
      loop: true,
      pagination: true,
      //threshold: 100,
      navigation: {
      prevEl: '.static-review-slider .prev-trigger',
      nextEl: '.static-review-slider .next-trigger',
      },
      breakpoints: {
        390: {
          slidesPerView: 1.3,
          spaceBetween: 28,
          centeredSlides: true,
        },
        600: {
          slidesPerView: 1.9,
          spaceBetween: 25,
          centeredSlides: true,
        },
        767: {
          slidesPerView: 2.8,
          spaceBetween: 15,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 10,
          centeredSlides: false,
        },
        1100: {
          slidesPerView: 4,
          spaceBetween: 10,
          centeredSlides: false,
        },
      },
      pagination: {
      el: '.review-slider .swiper-pagination-mobile',
			clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },
    },
    });
  swiperEl5.initialize();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["EP_Recent-articles"] && !Shopify.designMode) return;
  try {
    
  const swiperElrs = document.querySelector('swiper-container.recent_articles_slider')
  const paramsElrs = {
    injectStyles: [`
        span.swiper-notification {
          display:none;
        }
    `]
  };
      Object.assign(swiperElrs, {
        slidesPerView: 1.3,
        spaceBetween: 30,
        centeredSlides: true,
        loop: false,
        pagination: true,
        navigation: {
        prevEl: '.EP_Article_pg_full-width-relatad-article-section .prev-trigger',
        nextEl: '.EP_Article_pg_full-width-relatad-article-section .next-trigger',
        },
        breakpoints: {
          390: {
            slidesPerView: 1.3,
            spaceBetween: 10,
            centeredSlides: true,
            loop: true,
          },
          600: {
            slidesPerView: 1.3,
            spaceBetween: 10,
            centeredSlides: true,
            loop: true,
          },
          767: {
            slidesPerView: 2.3,
            spaceBetween: 10,
            centeredSlides: true,
            loop: true,
          },
          768: {
            slidesPerView: 2.3,
            spaceBetween: 10,
            centeredSlides: false,
            loop: false,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 15,
            centeredSlides: false,
            loop: false,
          },
        },
        pagination: {
        el: '.EP_Article_pg_full-width-relatad-article-section .swiper-pagination-mobile',
  			clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
      },
      },paramsElrs);
    swiperElrs.initialize();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["EP_global_static_review_slider"] && !Shopify.designMode) return;
  try {
    
const swiperElRG = document.querySelector('swiper-container.review-slider-global')
    Object.assign(swiperElRG, {
      pagination: true,
      navigation: {
      prevEl: '.static-review-slider.global .prev-trigger',
      nextEl: '.static-review-slider.global .next-trigger',
      },
      breakpoints: {
        390: {
          slidesPerView: 1.1,
          spaceBetween: 28,
          centeredSlides: true,
          loop: true,
        },
        600: {
          slidesPerView: 1.3,
          spaceBetween: 25,
          centeredSlides: true,
          loop: true,
        },
        767: {
          slidesPerView: 2.3,
          spaceBetween: 15,
          centeredSlides: true,
          loop: true,
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 10,
          centeredSlides: false,
          loop: false,
        },
        1100: {
          slidesPerView: 4,
          spaceBetween: 10,
          centeredSlides: false,
          loop: false,
        },
      },
      pagination: {
      el: '.review-slider-global .swiper-pagination-mobile.global',
		  clickable: true,
          renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },
    },
    });
  swiperElRG.initialize();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

 
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      //this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-ep-two-hands"] && !Shopify.designMode) return;
  try {
    
 const particles = [
  {
    width: 20,
    speed: 5,
    svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.196 26.493"><path d="M20.3,23.929c5.256-4.3,2.5-10.155-1.421-15.309C6.781-7.331-1.213,1.9.151,11.914,1.418,21.282,11.282,31.326,20.3,23.929" fill="#040505"/></svg>`
  },
  {
    width: 15,
    speed: 8,
    svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.359 17.542"><path d="M13.439,15.844C16.919,13,15.093,9.12,12.5,5.707,4.49-4.854-.8,1.257.1,7.888c.839,6.2,7.37,12.853,13.338,7.955" fill="#040505"/></svg>`
  },
  {
    width: 10,
    speed: 7,
    svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.359 17.542"><path d="M13.439,15.844C16.919,13,15.093,9.12,12.5,5.707,4.49-4.854-.8,1.257.1,7.888c.839,6.2,7.37,12.853,13.338,7.955" fill="#040505"/></svg>`
  },
  {
    width: 18,
    speed: 6,
    svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.359 17.542"><path d="M13.439,15.844C16.919,13,15.093,9.12,12.5,5.707,4.49-4.854-.8,1.257.1,7.888c.839,6.2,7.37,12.853,13.338,7.955" fill="#040505"/></svg>`
  }
];

function createParticleContainer(container, particle, index, isLeft) {
  const div = document.createElement('div');
  div.classList.add('particle');
  div.style.width = `${particle.width}px`;
  div.style.animationDuration = `${particle.speed}s`;
  div.style.animationDelay = `${index / particles.length}s`;
  div.style.opacity = '1';
  div.innerHTML = particle.svg;

  const direction = isLeft ? 'left' : 'right';
  div.style.animationName = `fall-${container.id}-${index}-${direction}`;
  document.styleSheets[0].insertRule(`
    @keyframes fall-${container.id}-${index}-${direction} {
      0% { transform: translate(${isLeft ? '-' : ''}100%, 0) rotate(0deg); opacity: 0; }
      10% { opacity: 1; }
      90% { opacity: 1; }
      100% { transform: translate(${isLeft ? '-' : ''}100%, ${container.offsetHeight - particle.width}px) rotate(360deg); opacity: 0; }
    }
  `);

  container.appendChild(div);
}

const leftContainer = document.querySelector('#left-particles-container');
const rightContainer = document.querySelector('#right-particles-container');

particles.forEach((particle, index) => {
  createParticleContainer(leftContainer, particle, index, true); // Pass true for left side
  createParticleContainer(rightContainer, particle, index, false); // Pass false for right side
});


  } catch(e) { console.error(e); }
})();
})();
